export const chapters = [
  {
    id: 3,
    part: 1,
    englishTitle: "The Land of Waves",
    kanjiTitle: "tbd",
    romanizedTitle: "tbd",
    available: false,
    parts: [
        {
            englishTitle: "The Demon of the Hidden Mist",
            label: "tbd", 
            available: false,
            content: `Content for The Demon of the Hidden Mist...`
        },
        {
            englishTitle: "An Enduring Village",
            label: "tbd", 
            available: false,
            content: `Content for An Enduring Village...`
        },
        {
            englishTitle: "The Bridge",
            label: "tbd", 
            available: false,
            content: `Content for The Bridge...`
        }
    ]
  }
];